const tagCollection = [
    {
        id: 1,
        name: "C",
        use: false
    },
    {
        id: 2,
        name: "C++",
        use: false
    },
    {
        id: 3,
        name: "JAVA",
        use: false
    },
    {
        id: 4,
        name: "DSA", // Data Structures and Algorithms
        use: false
    },
    {
        id: 5,
        name: "DBMS", // Database Management Systems
        use: false
    },
    {
        id: 6,
        name: "ReactJS",
        use: false
    },
    {
        id: 7,
        name: "NodeJS",
        use: false
    },
    {
        id: 8,
        name: "Problem Solving",
        use: false
    },
    {
        id: 9,
        name: "Python",
        use: false
    },
    {
        id: 10,
        name: "JavaScript",
        use: false
    },
    {
        id: 11,
        name: "HTML",
        use: false
    },
    {
        id: 12,
        name: "CSS",
        use: false
    },
    {
        id: 13,
        name: "Data Science",
        use: false
    },
    {
        id: 14,
        name: "Machine Learning",
        use: false
    },
    {
        id: 15,
        name: "Artificial Intelligence",
        use: false
    },
    {
        id: 16,
        name: "Operating Systems",
        use: false
    },
    {
        id: 17,
        name: "Computer Networks",
        use: false
    },
    {
        id: 18,
        name: "Software Engineering",
        use: false
    },
    {
        id: 19,
        name: "Cybersecurity",
        use: false
    },
    {
        id: 20,
        name: "Cloud Computing",
        use: false
    },
    {
        id: 21,
        name: "Big Data",
        use: false
    },
    {
        id: 22,
        name: "Blockchain",
        use: false
    },
    {
        id: 23,
        name: "DevOps",
        use: false
    },
    {
        id: 24,
        name: "Web Development",
        use: false
    },
    {
        id: 25,
        name: "Mobile App Development",
        use: false
    },
    {
        id: 26,
        name: "Agile Methodologies",
        use: false
    },
    {
        id: 27,
        name: "Version Control (Git)",
        use: false
    },
    {
        id: 28,
        name: "RESTful APIs",
        use: false
    },
    {
        id: 29,
        name: "GraphQL",
        use: false
    },
    {
        id: 30,
        name: "Docker",
        use: false
    },
    {
        id: 31,
        name: "Kubernetes",
        use: false
    },
    {
        id: 32,
        name: "Microservices",
        use: false
    },
    {
        id: 33,
        name: "Computer Vision",
        use: false
    },
    {
        id: 34,
        name: "Natural Language Processing",
        use: false
    },
    {
        id: 35,
        name: "TensorFlow",
        use: false
    },
    {
        id: 36,
        name: "PyTorch",
        use: false
    },
    {
        id: 37,
        name: "SQL",
        use: false
    },
    {
        id: 38,
        name: "NoSQL",
        use: false
    },
    {
        id: 39,
        name: "MongoDB",
        use: false
    },
    {
        id: 40,
        name: "PostgreSQL",
        use: false
    },
    {
        id: 41,
        name: "AWS",
        use: false
    },
    {
        id: 42,
        name: "Azure",
        use: false
    },
    {
        id: 43,
        name: "Google Cloud Platform",
        use: false
    },
    {
        id: 44,
        name: "Hadoop",
        use: false
    },
    {
        id: 45,
        name: "Spark",
        use: false
    },
    {
        id: 47,
        name: "Computer Graphics",
        use: false
    },
    {
        id: 48,
        name: "Human-Computer Interaction",
        use: false
    },
    {
        id: 49,
        name: "Augmented Reality",
        use: false
    },
    {
        id: 50,
        name: "Virtual Reality",
        use: false
    }
];

export default tagCollection;
